<template>
  <Header />
  <BreadCrumb 
   title="Terms & Conditions"        
        :breadcrumbs="[{ text: 'Terms & Conditions', to: '/terms-and-conditions' }]"
  
  />
  
  <TermsAndConditions :isWebTarget="true"/>
  <Newsletter />
  <Footer />
</template>

<script setup>
import TermsAndConditions from "@/components/TermsAndConditions.vue";
import Newsletter from "@/components/NewsletterBox.vue";
import Header from "@/components/Header.vue";
import BreadCrumb from "@/components/BreadCrumb.vue";
import Footer from "@/components/FooterArea.vue";
import "@fortawesome/fontawesome-free/css/all.css";
import { ref, onMounted } from "vue";
// export default {
//   name: "Terms_and_conditions",
//   components: {
//     Header,
//     BreadCrumb,
//     Newsletter,
//     Footer,
//   },
//   setup() {
//     // Define a reactive variable to hold the title
//     const pageTitle = ref("Salt - Terms & Conditions");

//     // Function to update the title
//     const updateTitle = () => {
//       document.title = pageTitle.value;
//     };

//     // Call updateTitle when component is mounted
//     onMounted(() => {
//       updateTitle();
//     });

//     return {
//       pageTitle,
//       updateTitle,
//     };
//   },
// };
</script>

<style scoped>
.terms {
  padding: 70px 0 0 0;
}
.textStyle {
  text-align: left;
}
.terms img {
  max-width: 100%;
}
.terms h2 {
  font-size: 55px;
  max-width: 100%;
  margin-bottom: 20px;
}
</style>
